export default __webpack_public_path__ + "static/media/seguridad24hs.cfcf2fbb.svg";